import script from "./TypingText.vue?vue&type=script&setup=true&lang=js"
export * from "./TypingText.vue?vue&type=script&setup=true&lang=js"

import "./TypingText.vue?vue&type=style&index=0&id=6137ccd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6137ccd0"]])

export default __exports__